<aumico-users-personal-information
    [supportedLocales]="supportedLocales"
    [defaultLanguage]="defaultLanguage"
    [organization]="organization"
    (personaInformationFormStatus)="onPersonalInformationFormStatusChange($event)"
    (personalInformationData)="onPersonalInformationFormValueChange($event)"
></aumico-users-personal-information>
<div class="continue-button" style="margin-top: 32px">
    <ham-button color="primary" [disabled]="!isPersonalInformationFormValid" (buttonClick)="showPasswordForm()">
        {{ localizations.aumico_reports_registration_create_account_button | i18next }}
    </ham-button>
</div>
